<template>
  <div class="embassy-notice-root">
    <embassy-notice-wrap v-if="interviewData" :interview-data="interviewData">
      <div class="embassy-notice-page">
        <div id="info" class="page-top scroll-panel">
          <section-interview-info
            :interview-data="interviewData"
            :is-weixin="isWeixin"
          />
        </div>
        <div class="page-body">
          <div id="material" class="scroll-panel">
            <section-carry-material :interview-data="interviewData" />
          </div>

          <section-check-reminder />
          <section-evus-reminder v-if="interviewData.need_evus" />
          <section-ems-reminder v-if="isAmericaInterview" />
          <section-material-file
            :interview-data="interviewData"
            :user-order-id="params.user_order_id"
            :order-applicant-id="params.order_applicant_id"
          />

          <div
            v-if="
              interviewData.need_delivery > 0 &&
              interviewData.tel_interview_notes &&
              interviewData.tel_interview_notes.length
            "
            id="phone"
            class="scroll-panel"
          >
            <section-tel-interview :interview-data="interviewData" />
          </div>

          <div id="process" class="scroll-panel">
            <section-attention-process :interview-data="interviewData" />
          </div>

          <section-ems-payment v-if="isAmericaInterview" />
        </div>
      </div>
    </embassy-notice-wrap>

    <app-downLoad class="app-download" :channel="channel" v-if="isWeixin" />
  </div>
</template>

<script>
import http from '../../services/http';
import util from '../../services/tools';
import countryService from '../../services/countryService';
import appDownLoad from '../../components/appDownLoad';
import EmbassyNoticeWrap from './components/EmbassyNoticeWrap.vue';
import SectionInterviewInfo from './components/SectionInterviewInfo.vue';
import SectionCarryMaterial from './components/SectionCarryMaterial.vue';
import SectionCheckReminder from './components/SectionCheckReminder.vue';
import SectionEvusReminder from './components/SectionEvusReminder.vue';
import SectionEmsReminder from './components/SectionEmsReminder.vue';
import SectionMaterialFile from './components/SectionMaterialFile.vue';
import SectionTelInterview from './components/SectionTelInterview.vue';
import SectionAttentionProcess from './components/SectionAttentionProcess.vue';
import SectionEmsPayment from './components/SectionEmsPayment.vue';

export default {
  name: 'NewEmbassyNotice',
  components: {
    appDownLoad,
    EmbassyNoticeWrap,
    SectionInterviewInfo,
    SectionCarryMaterial,
    SectionCheckReminder,
    SectionEvusReminder,
    SectionEmsReminder,
    SectionMaterialFile,
    SectionTelInterview,
    SectionAttentionProcess,
    SectionEmsPayment,
  },
  data() {
    return {
      params: {
        user_order_id: 0,
        order_applicant_id: 0,
      },
      interviewData: null,
      // 老逻辑，很奇怪，感觉其实意思就是不是APP，这个就是true
      isWeixin: false,
      channel: 'rrqah2w2',
    };
  },
  computed: {
    isAmericaInterview() {
      if (!this.interviewData || !this.interviewData.visa_country_id)
        return false;
      return (
        this.interviewData.visa_country_id ===
          countryService.getCountryId('america') &&
        this.interviewData.need_interview
      );
    },
  },
  created() {
    util.init();
    this.initAppEnv();

    const query = this.$route.query || {};
    this.params.user_order_id = +(
      query.user_order_id ||
      this.$route.params.orderId ||
      0
    );
    this.params.order_applicant_id = +(
      query.order_applicant_id ||
      this.$route.params.applicantId ||
      0
    );
    this.requestInfo();
  },
  methods: {
    initAppEnv() {
      this.isWeixin = util.isWeixin();
      util.getBridge.bind(util)((bridge) => {
        if (util.getOS() === 'android') {
          bridge.init((message, responseCallback) => {
            responseCallback({ loaded: true });
          });
        }

        this.isWeixin = false;
      });

      if (!this.isWeixin) {
        setTimeout(() => {
          if (!window.WebViewJavascriptBridge) {
            this.isWeixin = true;
          }
        }, 500);
      }
    },
    requestInfo() {
      const { user_order_id, order_applicant_id } = this.params;
      if (!user_order_id || !order_applicant_id) return;

      http
        .newPost('h5/applicant_interview_query', {
          user_order_id,
          order_applicant_id,
          is_app: 1,
        })
        .then((res) => {
          if (res.interview_time === '0000-00-00 00:00:00') {
            return;
          }

          this.interviewData = res;
        })
        .catch((error) => console.error(error));
    },
  },
};
</script>

<style lang="less" scoped>
.embassy-notice-root {
  min-height: 100vh;
  background: #f3f6f9;
}

.embassy-notice-page {
  box-sizing: border-box;
  min-height: 100vh;
  background: #f3f6f9;

  .page-top {
    background: url('https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-wxa/interview/interview-notice/top-bg.png')
      no-repeat center center / 100% 100%;
    padding: 16px 12px 40px 12px;
  }

  .page-body {
    margin-top: -24px;
    padding-bottom: 80px;
  }
}
</style>
